<template>
<div class="iccidPriceSwitchList table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">VIP智能切网列表</span>
        <el-form inline class="hook right themed-form search-form" v-model="form" style="line-height: 40px;">
            <el-form-item label="ICCID:">
                <el-input v-model="form.iccid" placeholder="短号或ICCID" clearable=""></el-input>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="handleAdd">新增</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-upload2" class="themed-button" @click="importData">导入</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-delete" class="themed-button" @click="batchDelete">批量删除</el-button>
            </el-form-item>
        </el-form>
    </div>
    
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
            <!-- <el-table-column label="ID" prop="id" show-overflow-tooltip></el-table-column> -->
            <el-table-column label="ICCID" prop="iccid" show-overflow-tooltip></el-table-column>
            <el-table-column label="价格" prop="price" show-overflow-tooltip>
                <template slot-scope="scope">
                    ¥{{ scope.row.price }}
                </template>
            </el-table-column>
              <el-table-column label="天数" prop="days" show-overflow-tooltip></el-table-column>
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="300px">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" class="themed-button" @click="handleOrderList(scope.row)">订单列表</el-button>
                    <el-button type="primary" size="mini" class="themed-button" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button type="danger" size="mini" class="themed-button" @click="deleteById(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 50, 100, 1000]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <!-- 新增/编辑弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="editDialogVisible" width="500px">
        <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="100px">
            <el-form-item label="ICCID:" prop="iccid">
                <el-input v-model="editForm.iccid" placeholder="请输入短号或ICCID" :disabled="isEdit"></el-input>
            </el-form-item>
            <el-form-item label="价格:" prop="price">
                <el-input 
                    v-model="editForm.price" 
                    placeholder="请输入价格" 
                    @input="handlePriceInput">
                    <template slot="prepend">¥</template>
                </el-input>
            </el-form-item>
            <el-form-item label="天数:" prop="days">
                <el-input-number 
                    v-model="editForm.days" 
                    :min="1"
                    :precision="0"
                    :controls="true"
                    placeholder="请输入天数">
                </el-input-number>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="themed-button" type="primary" @click="submitEdit">确 定</el-button>
            <el-button class="themed-button" type="primary" @click="cancelEdit">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 导入弹框 -->
    <el-dialog title="批量导入" :visible.sync="importDialogVisible" width="600px">
        <el-form label-position="right" label-width="180px" style="max-height:500px;overflow:auto">
            <el-form-item label="上传文件（excel）:" required>
                <input class="file-input" type="file" ref='importFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
            <el-form-item label="ICCID价格信息:">
                <el-input v-model="importInfo" type="textarea" rows="6" placeholder="请输入ICCID 价格 天数,每行一组,用空格分开,天数可为空,默认30"></el-input>
                <div style="color:#f00;">请输入ICCID 价格 天数,每行一组,用空格分开,天数可为空,默认30</div>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitImport">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="importDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 批量删除弹框 -->
    <el-dialog title="批量删除" :visible.sync="deleteDialogVisible" width="500px">
        <el-form label-position="right" label-width="200px" style="max-height:500px;">
            <el-form-item label="上传文件（excel）:" required>
                <input class="file-input" type="file" ref='deleteFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
            <el-form-item label="ICCID信息:">
                <el-input v-model="deleteInfo" type="textarea" rows="6" placeholder="请输入短号或ICCID，每行一个"></el-input>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitBatchDelete">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportDeleteTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="deleteDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { 
    listIccidPriceSwitch, 
    deleteById, 
    saveIccidPriceSwitch,
    batchImportSync,
    batchDeleteSync
} from '@/api/iccidPriceSwitch/list.js'
import { messageBox, confirmBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'
import Utils from '@/utils/utils.js'
import {exportTemplate} from '@/api/statistics.js'

export default {
    name: 'iccidPriceSwitchList',
    mixins: [resize],
    data() {
        return {
            form: {
                iccid: ''
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,

            // 编辑弹框数据
            editDialogVisible: false,
            editForm: {
                id: '',
                iccid: '',
                price: '',
                days: 30
            },
            isEdit: false,
            dialogTitle: '新增',

            // 导入弹框数据
            importDialogVisible: false,
            importInfo: '',

            // 批量删除弹框数据
            deleteDialogVisible: false,
            deleteInfo: '',

            // 新增/编辑弹框表单验证规则
            editRules: {
                iccid: [
                    { required: true, message: '请输入ICCID', trigger: 'blur' },
                    { min: 3, max: 50, message: 'ICCID长度应在3到50个字符之间', trigger: 'blur' }
                ],
                price: [
                    { required: true, message: '请输入价格', trigger: 'blur' },
                    { validator: this.validatePrice, trigger: 'blur' }
                ],
                days: [
                    { required: true, message: '请输入天数', trigger: 'blur' },
                    { type: 'number', min: 1, message: '天数必须大于0', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        this.getList()
    },
    activated() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form
            }
            
            listIccidPriceSwitch(params).then(res => {
                if (res && res.page) {
                    this.tableData = res.page.rows || []
                    this.total = res.page.total || 0
                }
            })
        },

        // 搜索
        searchData() {
            this.currentPage = 1
            this.getList()
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getList()
        },

        // 删除单条
        deleteById(row) {
            confirmBox(this, `确定要删除ICCID为 ${row.iccid} 的记录吗？`, '操作提示', () => {
                deleteById({ id: row.id }).then(res => {
                    messageBox(this, '删除成功')
                    this.getList()
                })
            })
        },

        // 新增操作
        handleAdd() {
            this.editForm = {
                id: '',
                iccid: '',
                price: '',
                days: 30
            }
            this.isEdit = false
            this.dialogTitle = '新增'
            this.editDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.clearValidate()
                }
            })
        },

        // 编辑操作
        handleEdit(row) {
            this.editForm = {
                id: row.id,
                iccid: row.iccid,
                price: row.price,
                days: row.days
            }
            this.isEdit = true
            this.dialogTitle = '编辑'
            this.editDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.clearValidate()
                }
            })
        },

        // 提交编辑
        submitEdit() {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    // 确保价格是数字类型
                    const formData = {
                        ...this.editForm,
                        price: parseFloat(this.editForm.price)
                    }
                    
                    // 验证价格大于0且最多两位小数
                    if (formData.price <= 0) {
                        this.$message.warning('价格必须大于0')
                        return
                    }
                    
                    // 检查小数位数
                    const priceStr = formData.price.toString()
                    if (priceStr.includes('.') && priceStr.split('.')[1].length > 2) {
                        this.$message.warning('价格最多只能有两位小数')
                        return
                    }
                    
                    saveIccidPriceSwitch(formData).then(res => {
                        if (res.system_result_key === '0') {
                            this.$message.success(res.system_result_message_key || '操作成功')
                            this.editDialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.system_result_message_key || '操作失败')
                        }
                    }).catch(err => {
                        this.$message.error('操作失败，请稍后重试')
                        console.error(err)
                    })
                }
            })
        },

        // 取消编辑
        cancelEdit() {
            this.editDialogVisible = false
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.clearValidate()
                }
            })
        },

        // 导入操作
        importData() {
            this.importDialogVisible = true
        },

        // 提交导入
        submitImport() {
            let file = this.$refs['importFile'].files[0];
            let formData = new FormData();
            
            // 处理信息
            if (!file && !this.importInfo.trim()) {
                messageBox(this, '请选择文件或输入ICCID价格信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', file);
            }
            
            // 无论是否有文件，都添加信息到表单
            formData.append('iccids', this.importInfo);
            
            batchImportSync(formData).then(res => {
                console.log(res)
                if (res.system_result_key == '0') {
                    if (file) {
                        this.$alert(res.system_result_message_key || '导入成功，请到导入记录中下载', '提示', {
                            confirmButtonText: '确定',
                        }).then(() => {
                            this.$refs['importFile'].value = '';
                            this.importInfo = '';
                            this.importDialogVisible = false;
                            this.$router.push('/tob/i_import_list');
                        })
                    } else {
                        this.$message.success(res.system_result_message_key || '导入成功');
                        this.importInfo = '';
                        this.importDialogVisible = false;
                        this.getList();
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 导出模板
        exportTemplate() {
            exportTemplate({name: 'importIccidPrice.xls'}).then(res => {
                const filename = 'importIccidPrice.xls'
                Utils.createDownload(res, filename)
            })
        },

        // 批量删除操作
        batchDelete() {
            this.deleteDialogVisible = true
        },

        // 提交批量删除
        submitBatchDelete() {
            let file = this.$refs['deleteFile'].files[0];
            let formData = new FormData();
            
            // 处理信息
            if (!file && !this.deleteInfo.trim()) {
                messageBox(this, '请选择文件或输入ICCID信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', file);
            }
            
            // 无论是否有文件，都添加信息到表单
            formData.append('iccids', this.deleteInfo);
            
            batchDeleteSync(formData).then(res => {
                if (res.system_result_key == '0') {
                    if (file) {
                        this.$alert(res.system_result_message_key || '删除成功，请到导入记录中查看', '提示', {
                            confirmButtonText: '确定',
                        }).then(() => {
                            this.$refs['deleteFile'].value = '';
                            this.deleteInfo = '';
                            this.deleteDialogVisible = false;
                            this.$router.push('/tob/i_import_list');
                        })
                    } else {
                        this.$message.success(res.system_result_message_key || '删除成功');
                        this.deleteInfo = '';
                        this.deleteDialogVisible = false;
                        this.getList();
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 导出删除模板
        exportDeleteTemplate() {
            exportTemplate({name: 'importIccidOrShort.xls'}).then(res => {
                const filename = 'importIccidOrShort.xls'
                Utils.createDownload(res, filename)
            })
        },

        // 订单列表操作
        handleOrderList(row) {
            this.$router.push({
                path: '/iccidPriceSwitch/orderList',
                query: { iccid: row.iccid }
            })
        },
        
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            
            try {
                // 处理ISO格式的时间字符串
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;
                
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error('日期格式化错误:', error);
                return dateTime;
            }
        },

        // 处理价格输入
        handlePriceInput(value) {
            // 移除所有非数字和小数点的字符
            let cleanValue = value.replace(/[^\d.]/g, '');
            
            // 确保只有一个小数点
            const parts = cleanValue.split('.');
            if (parts.length > 2) {
                cleanValue = parts[0] + '.' + parts.slice(1).join('');
            }
            
            // 限制小数点后最多两位
            if (parts.length === 2 && parts[1].length > 2) {
                cleanValue = parts[0] + '.' + parts[1].slice(0, 2);
            }
            
            // 防止以多个0开头（除了0.xx的情况）
            if (cleanValue.length > 1 && cleanValue[0] === '0' && cleanValue[1] !== '.') {
                cleanValue = cleanValue.substring(1);
            }
            
            // 更新输入框的值
            this.editForm.price = cleanValue;
        },

        // 自定义价格验证器
        validatePrice(rule, value, callback) {
            if (!value || value === '') {
                callback(new Error('请输入价格'));
            } else if (isNaN(value)) {
                callback(new Error('价格必须是数字'));
            } else if (parseFloat(value) <= 0) {
                callback(new Error('价格必须大于0'));
            } else if (parseFloat(value) > 999999.99) {
                callback(new Error('价格不能超过999999.99'));
            } else if (value.toString().includes('.') && value.toString().split('.')[1].length > 2) {
                callback(new Error('价格最多只能有两位小数'));
            } else {
                callback();
            }
        }
    }
}
</script>

<style scoped>
.iccidPriceSwitchList {
    padding: 20px;
}

.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}

.file-input {
    display: inline-block;
}

.mt5 {
    margin-top: 5px;
}

.align-right {
    text-align: right;
    margin-top: 20px;
}

.text-color {
    color: #606266;
}
</style> 